/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import type {
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  EditorConfig,
  LexicalEditor,
  LexicalNode,
  Spread,
} from 'lexical';

import {
  DecoratorBlockNode,
  SerializedDecoratorBlockNode,
} from '@lexical/react/LexicalDecoratorBlockNode';
import FormulaNodeComponent from './Components/FormulaNodeComponent';

type FormulaNodeType = 'formula-node';
const TYPE = 'formula-node';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
function convertFormulaElement(domNode: HTMLDivElement): DOMConversionOutput | null {
  const node = $createFormulaNode();
  return { node };
}

export type SerializedFormulaNode = Spread<{ type: FormulaNodeType; version: 1;}, SerializedDecoratorBlockNode>;

export class FormulaNode extends DecoratorBlockNode {
  static getType(): string {
    return TYPE;
  }

  static clone(node: FormulaNode): FormulaNode {
    return new FormulaNode(node.__format, node.__key);
  }

  static importJSON(serializedNode: SerializedFormulaNode): FormulaNode {
    const node = $createFormulaNode();
    node.setFormat(serializedNode.format);
    return node;
  }

  exportJSON(): SerializedFormulaNode {
    return {
      ...super.exportJSON(),
      type: TYPE,
      version: 1,
    };
  }

  static importDOM(): DOMConversionMap<HTMLDivElement> | null {
    return {
      div: (domNode: HTMLDivElement) => {
        if (!domNode.hasAttribute('data-lexical-card-link-id')) {
          return null;
        }
        return {
          conversion: convertFormulaElement,
          priority: 2,
        };
      },
    };
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('div');
    element.setAttribute('data-lexical-card-link-id', this.__id);
    return { element };
  }

  getId(): string {
    return this.__id;
  }

  decorate(editor: LexicalEditor, config: EditorConfig): JSX.Element {
    const embedBlockTheme = config.theme.embedBlock || {};
    const className = {
      base: embedBlockTheme.base || '',
      focus: embedBlockTheme.focus || '',
    };
    return (
      <FormulaNodeComponent
        className={className}
        format={this.__format}
        nodeKey={this.getKey()}
      />
    );
  }

  isTopLevel(): true {
    return true;
  }
}

export function $createFormulaNode(): FormulaNode {
  return new FormulaNode();
}

export function $isFormulaNode(
  node: FormulaNode | LexicalNode | null | undefined,
): node is FormulaNode {
  return node instanceof FormulaNode;
}
